import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1 .643C1 .288 1.275 0 1.614 0h2.454c.34 0 .614.288.614.643V4.5c0 .355-.275.643-.614.643H1.614C1.274 5.143 1 4.855 1 4.5zm1.227.643v2.571h1.228V1.286zM6.318.643c0-.355.275-.643.614-.643h1.227c.339 0 .614.288.614.643v3.214h.613c.34 0 .614.288.614.643s-.275.643-.614.643H6.932c-.34 0-.614-.288-.614-.643s.275-.643.614-.643h.613V1.286h-.613c-.34 0-.614-.288-.614-.643M1 7.5c0-.355.275-.643.614-.643H2.84c.339 0 .614.288.614.643v3.214h.613c.34 0 .614.288.614.643S4.407 12 4.068 12H1.614c-.34 0-.614-.288-.614-.643s.275-.643.614-.643h.613V8.143h-.613C1.274 8.143 1 7.855 1 7.5m5.318 0c0-.355.275-.643.614-.643h2.454c.34 0 .614.288.614.643v3.857c0 .355-.275.643-.614.643H6.932c-.34 0-.614-.288-.614-.643zm1.227.643v2.571h1.228V8.143z"
    }, null, -1)
  ]))]))
}
export default { render: render }